import { createRouter, createWebHistory } from 'vue-router'
import store from "../store";
import auth from '../middleware/auth'
import authTwo from '../middleware/authTwo'
import middlewarePipeline from './middlewarePipeline'

import AdminLayout from '@/layout/AdminLayout.vue'
import SuperAdminLayout from '@/layout/SuperAdminLayout.vue'
import UserLayout from '@/layout/UserLayout.vue';

const routes = [
  {
    path: '/',
    name: 'LandingPagee',
    component: UserLayout,
    meta: {
      middleware: [
        auth,
        authTwo
      ],
      portal: 'Homepage'
    },
    children: [
      {
        path: "",
        redirect: () => (localStorage.getItem("token") ? "/pricing" : "/login"),
      },
      {
        path: "/pricing",
        name: "PricingPage",
        component: () => import("../views/Landing/Pricing.vue"),
        meta: { authRequired: false, title: 'Pricing | Strata Yourself' },
      },
    ]
  },
  {
    path: '/admin',
    name: 'HomePage',
    component: AdminLayout,
    meta: {
      middleware: [
        auth
      ],
      portal: 'Admin'
    },
    children: [
      {
        path: "",
        name: "DashboardPage",
        component: () => import("../views/admin/Dashboard.vue"),
        meta: { authRequired: false, title: 'Home | Strata Yourself' },
      },
      {
        path: "/units",
        name: "UnitsPage",
        component: () => import("../views/admin/Units.vue"),
        meta: { authRequired: false, title: 'Unit | Strata Yourself' },
      },
      {
        path: "/member",
        name: "MemberPage",
        component: () => import("../views/admin/member/Member.vue"),
        meta: { authRequired: false, title: 'Member | Strata Yourself' },
      },
      {
        path: "/member-details=:id",
        name: "MemberDetailsPage",
        component: () => import("../views/admin/member/Member_details.vue"),
        meta: { authRequired: false, title: 'Member Details | Strata Yourself' },
      },
      {
        path: "/announcements",
        name: "AnnouncementsPage",
        component: () => import("../views/admin/notice/Announcements.vue"),
        meta: { authRequired: false, title: 'Announcements | Strata Yourself' },
      },
      {
        path: "/announcement-details=:id",
        name: "AnnouncementDetailsPage",
        component: () => import("../views/admin/notice/Announcement_Details.vue"),
        meta: { authRequired: false, title: 'Announcement Details | Strata Yourself' },
      },
      {
        path: "/discussion",
        name: "DiscussionsPage",
        component: () => import("../views/admin/discussion/Discussions.vue"),
        meta: { authRequired: false, title: 'Discussions | Strata Yourself' },
      },
      {
        path: "/discussion-details=:id",
        name: "DiscussionDetailsPage",
        component: () => import("../views/admin/discussion/Discussion_Details.vue"),
        meta: { authRequired: false, title: 'Discussion Details | Strata Yourself' },
      },
      {
        path: "/messaging",
        name: "MessagingPage",
        component: () => import("../views/admin/Messaging.vue"),
        meta: { authRequired: false, title: 'Messaging | Strata Yourself' },
      },
      {
        path: "/meeting",
        name: "MeetingPage",
        component: () => import("../views/admin/meeting/Meetings.vue"),
        meta: { authRequired: false, title: 'Meetings | Strata Yourself' },
      },
      {
        path: "/meeting-details=:id",
        name: "MeetingDetailsPage",
        component: () => import("../views/admin/meeting/Meeting_Details.vue"),
        meta: { authRequired: false, title: 'Meeting Details | Strata Yourself' },
      },
      {
        path: "/edit-agenda=:id",
        name: "EditAgendaPage",
        component: () => import("../views/admin/meeting/Edit_Agenda.vue"),
        meta: { authRequired: false, title: 'Edit Agenda | Strata Yourself' },
      },
      {
        path: "/edit-minutes=:id",
        name: "EditMinutesPage",
        component: () => import("../views/admin/meeting/Edit_Minutes.vue"),
        meta: { authRequired: false, title: 'Edit Minutes | Strata Yourself' },
      },
      {
        path: "/polling",
        name: "PollingPage",
        component: () => import("../views/admin/Polling.vue"),
        meta: { authRequired: false, title: 'Polling | Strata Yourself' },
      },
      {
        path: "/finance",
        name: "FinancePage",
        component: () => import("../views/admin/finance/Finance.vue"),
        meta: { authRequired: false, title: 'Finance | Strata Yourself' },
      },
      {
        path: "/finance-specific",
        name: "FinancePageSpecific",
        component: () => import("../views/admin/finance/FinanceSpecific.vue"),
        meta: { authRequired: false, title: 'Finance | Strata Yourself' },
      },
      {
        path: "/seed-account",
        name: "SeedPage",
        component: () => import("../views/admin/finance/SeedAccount.vue"),
        meta: { authRequired: false, title: 'Seed Account | Strata Yourself' },
      },
      {
        path: "/tax-invoice=:id",
        name: "TaxInvoicePage",
        component: () => import("../views/admin/finance/inner/TaxInvoice.vue"),
        meta: { authRequired: false, title: 'Tax Invoice | Strata Yourself' },
      },
      {
        path: "/venues",
        name: "VenuesPage",
        component: () => import("../views/admin/venues/Venues.vue"),
        meta: { authRequired: false, title: 'Venues | Strata Yourself' },
      },
      // {
      //   path: "/pinboard",
      //   name: "PinboardPage",
      //   component: () => import("../views/admin/Pinboard.vue"),
      //   meta: { authRequired: false, title: 'Pinboard | Strata Yourself' },
      // },
      {
        path: "/document",
        name: "DocumentPage",
        component: () => import("../views/admin/document/Documents.vue"),
        meta: { authRequired: false, title: 'Documents | Strata Yourself' },
      },
      // {
      //   path: "/document-pinboard",
      //   name: "DocumentPinboardPage",
      //   component: () => import("../views/admin/document/Document_Pinboard.vue"),
      //   meta: { authRequired: false, title: 'Document Pinboard | Strata Yourself' },
      // },
      {
        path: "/sub-document-:id",
        name: "SubDocumentPage",
        component: () => import("../views/admin/document/Sub_Document.vue"),
        meta: { authRequired: false, title: 'Documents | Strata Yourself' },
      },
      // {
      //   path: "/link",
      //   name: "LinkPage",
      //   component: () => import("../views/admin/Links.vue"),
      //   meta: { authRequired: false, title: 'Link | Strata Yourself' },
      // },
      {
        path: "/user-subscriptions",
        name: "SubscriptionUserPage",
        component: () => import("../views/admin/Subscription.vue"),
        meta: { authRequired: false, title: 'Subscriptions | Strata Yourself' },
      },
      {
        path: "/user-transactions",
        name: "TransactionUserPage",
        component: () => import("../views/admin/Transaction.vue"),
        meta: { authRequired: false, title: 'Transactions | Strata Yourself' },
      },
      {
        path: "/my-profile",
        name: "MyProfilePage",
        component: () => import("../views/admin/profile/MyProfile.vue"),
        meta: { authRequired: false, title: 'My Profile | Strata Yourself' },
      },
      {
        path: "/setting",
        name: "ProfilePage",
        component: () => import("../views/admin/profile/Setting.vue"),
        meta: { authRequired: false, title: 'Settings | Strata Yourself' },
      },
      {
        path: "/edit-setting",
        name: "EditSettingPage",
        component: () => import("../views/admin/profile/EditSetting.vue"),
        meta: { authRequired: false, title: 'Edit Settings | Strata Yourself' },
      },
    ]
  },
  {
    path: '/super-admin',
    name: 'SuperHomePage',
    component: SuperAdminLayout,
    meta: {
      middleware: [
        auth
      ],
      portal: 'SuperAdmin'
    },
    children: [
      {
        path: "",
        name: "SuperDashboardPage",
        component: () => import("../views/superAdmin/Dashboard.vue"),
        meta: { authRequired: false, title: 'Home | Strata Yourself' },
      },
      {
        path: "/users",
        name: "UsersPage",
        component: () => import("../views/superAdmin/Users.vue"),
        meta: { authRequired: false, title: 'Users | Strata Yourself' },
      },
      {
        path: "/super-profile",
        name: "SuperMyProfilePage",
        component: () => import("../views/admin/profile/MyProfile.vue"),
        meta: { authRequired: false, title: 'My Profile | Strata Yourself' },
      },
      {
        path: "/view-dashboard",
        name: "ViewAdminDashboardPage",
        component: () => import("../views/superAdmin/View_Admin_Dashboard.vue"),
        meta: { authRequired: false, title: 'View Admin Dashboard | Strata Yourself' },
      },
      {
        path: "/subscriptions",
        name: "SubscriptionsPage",
        component: () => import("../views/superAdmin/Subscriptions.vue"),
        meta: { authRequired: false, title: 'Subscriptions | Strata Yourself' },
      },
      {
        path: "/products",
        name: "ProductsPage",
        component: () => import("../views/superAdmin/products/Products.vue"),
        meta: { authRequired: false, title: 'Products | Strata Yourself' },
      },
      {
        path: "/product-details",
        name: "ProductDetailsPage",
        component: () => import("../views/superAdmin/products/Product_Details.vue"),
        meta: { authRequired: false, title: 'Product Details | Strata Yourself' },
      },
      {
        path: "/active-subscription",
        name: "ActiveSubscriptionPage",
        component: () => import("../views/superAdmin/products/Active_Subscription.vue"),
        meta: { authRequired: false, title: 'Active Subscription | Strata Yourself' },
      },
      {
        path: "/bot",
        name: "TrainBotPage",
        component: () => import("../views/superAdmin/bot/Bot.vue"),
        meta: { authRequired: false, title: 'Train Bot | Strata Yourself' },
      },
      {
        path: "/transactions",
        name: "TransactionsPage",
        component: () => import("../views/superAdmin/Transactions.vue"),
        meta: { authRequired: false, title: 'Transactions | Strata Yourself' },
      },
      {
        path: "/users-token",
        name: "UsersToken",
        component: () => import("../views/superAdmin/UsersToken.vue"),
        meta: { authRequired: false, title: 'UserTokens | Strata Yourself' },
      },
      {
        path: "/trial-settings",
        name: "TrialSettingsPage",
        component: () => import("../views/superAdmin/TrialSettings.vue"),
        meta: { authRequired: false, title: 'Trial Settings | Strata Yourself' },
      },
      {
        path: "/stripe-settings",
        name: "StripeSettings",
        component: () => import("../views/superAdmin/Settings.vue"),
        meta: { authRequired: false, title: 'Stripe Settings | Strata Yourself' },
      },
    ]
  },

  //Payment page for stripe
  {
    path: "/payment",
    name: "PaymentPage",
    component: () => import("../views/Landing/stripeCheckout.vue"),
    meta: { authRequired: false, title: 'Payment | Strata Managemen' },
  },

  // Login page
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
    meta: { authRequired: false, title: 'Login | Strata Yourself' },
  },
  // Register page
  {
    path: '/complete-registration',
    name: 'Complete Registration',
    component: () => import(/* webpackChunkName: "about" */ '../views/CompleteRegistration.vue'),
    meta: { authRequired: false, title: 'Complete Register | Strata Yourself' },
  },
  {
    path: '/complete-strata-registration',
    name: 'Complete Strata Registration',
    component: () => import(/* webpackChunkName: "about" */ '../views/createStrata.vue'),
    meta: { authRequired: false, title: 'Create Strata | Strata Yourself' },
  },
  {
    path: '/register',
    name: 'RegisterPage',
    component: () => import(/* webpackChunkName: "about" */ '../views/Register.vue'),
    meta: { authRequired: false, title: 'Admin Register | Strata Yourself' },
  },
  // Register page
  {
    path: '/member-register=:id',
    name: 'MemberRegisterPage',
    component: () => import(/* webpackChunkName: "about" */ '../views/MemberRegister.vue'),
    meta: { authRequired: false, title: 'Member Register | Strata Yourself' },
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import(/* webpackChunkName: "about" */ '../views/ResetPassword.vue'),
    meta: { authRequired: false, title: 'Reset Password | Strata Yourself' },
  },
  {
    path: '/activate-account',
    name: 'ActivateAccount',
    component: () => import(/* webpackChunkName: "about" */ '../views/ActivateAccount.vue'),
    meta: { authRequired: false, title: 'Activate Account | Strata Yourself' },
  },

  // Error pages
  {
    path: '/500',
    name: 'ServerError',
    component: () => import(/* webpackChunkName: "about" */ '../views/errors/ServerError.vue'),
    meta: { authRequired: false, title: 'Server Error | Strata Yourself' },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "about" */ '../views/errors/NotFound.vue'),
    meta: { authRequired: false, title: 'Page Not Found | Strata Yourself' },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Strata Yourself';

  window.scrollTo(0, 0);

  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware
  const context = {
    to,
    from,
    next,
    store
  }

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
});

export default router
